import Map from "@/components/maps/map";
import TopBar from "@/components/top-bar";

export default function MapLayout({ children }: { children: React.ReactNode }) {
  return (
    <>
      <Map />
      <TopBar />
      {children}
    </>
  );
}
